/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import {
    IMultiLevelDatasetNode,
    IMultiLevelDatasetVisitNode,
    IMultiLevelDatasetVisitor
} from '../types/MultiLevelDatasetTypes';

function visitMultiLevelDatasetNodeInternal<T>(
    node: IMultiLevelDatasetNode,
    preVisit: IMultiLevelDatasetVisitNode<T> | undefined,
    postVisit: IMultiLevelDatasetVisitNode<T> | undefined, context: T,
    currentDepth = 0, currentIndex = 0
): T {
    let processedContext = context;

    if (preVisit) {
        processedContext = preVisit(node, context, currentDepth, currentIndex);
    }

    node.children.forEach((child, index) => {
        processedContext = visitMultiLevelDatasetNodeInternal(child, preVisit, postVisit, processedContext, currentDepth + 1, index);
    });

    if (postVisit) {
        processedContext = postVisit(node, processedContext, currentDepth, currentIndex);
    }

    return processedContext;
}

export default function visitMultiLevelDatasetNode<T>(node: IMultiLevelDatasetNode, visitor: IMultiLevelDatasetVisitor<T>, context: T): T {
    let processedContext: T = context;

    if (visitor.preVisit) {
        processedContext = visitor.preVisit(context);
    }

    processedContext = visitMultiLevelDatasetNodeInternal(node, visitor.preVisitNode, visitor.postVisitNode, processedContext);

    if (visitor.postVisit) {
        processedContext = visitor.postVisit(context);
    }

    return processedContext;
}
